/* eslint-disable max-len */
import { FunctionComponent } from 'react';

const PixMP: FunctionComponent = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <title>simbolo_pix_policromia_positivo_outline_reducao_maxima</title>
    <defs>
      <circle id="path-1" cx="20" cy="20" r="20" />
      <polygon id="path-3" points="0.8497 0.538024814 15.137 0.538024814 15.137 10.985 0.8497 10.985" />
      <polygon id="path-5" points="0.849 0 15.136 0 15.136 10.4673752 0.849 10.4673752" />
      <polygon id="path-7" points="0 0.686 23.999 0.686 23.999 11.3146 0 11.3146" />
    </defs>
    <g id="Registro-MP---nativo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="HUB---Validación-de-teléfono-mlb" transform="translate(-28.000000, -490.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="360" height="640" />
        <g id="Group-2" transform="translate(20.000000, 468.000000)">
          <g id="Group-4" transform="translate(0.000000, 14.000000)">
            <g id="Thumbnail">
              <g id="一-/-Thumbnail-/-BG-/-ICON-Default">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1" />
                  <circle strokeOpacity="0.0700000003" stroke="#000000" cx="20" cy="20" r="19.5" />
                </mask>
              </g>
              <g id="Badge-/-Large-/-Pill-/-📢Loud-2" transform="translate(28.000000, 24.000000)" />
              <g id="simbolo_pix_policromia_positivo_outline_reducao_maxima" transform="translate(8.000000, 8.000000)">
                <g id="Group-3" transform="translate(4.000000, 13.000000)">
                  <mask id="mask-4" fill="white">
                    <use xlinkHref="#path-3" />
                  </mask>
                  <g id="Clip-2" />
                  <path d="M9.503,8.8574 C9.103,9.2578 8.569,9.4785 8,9.4785 L8,9.4785 C7.431,9.4785 6.897,9.2578 6.497,8.8574 L3.8311,6.1924 C4.2008,5.9756 4.5421,5.7119 4.8512,5.4023 L7.849,2.4043 L10.861,5.416 C11.219,5.7754 11.619,6.0723 12.056,6.3047 L9.503,8.8574 Z M14.428,5.373 C13.486,5.373 12.601,5.0059 11.935,4.3408 L8.322,0.7274 C8.069,0.4754 7.629,0.4744 7.376,0.7274 L3.7765,4.3281 C3.1105,4.9932 2.2247,5.3594 1.2833,5.3594 L0.8497,5.3594 L5.422,9.9316 C6.846,11.3555 9.154,11.3555 10.578,9.9316 L15.137,5.373 L14.428,5.373 L14.428,5.373 Z" id="Fill-1" fill="#009EE3" mask="url(#mask-4)" />
                </g>
                <g id="Group-6" transform="translate(4.000000, 0.000000)">
                  <mask id="mask-6" fill="white">
                    <use xlinkHref="#path-5" />
                  </mask>
                  <g id="Clip-5" />
                  <path d="M10.86,5.584 L7.849,8.595 L4.8502,5.596 C4.5411,5.288 4.1998,5.024 3.8306,4.808 L6.496,2.142 C7.326,1.314 8.675,1.313 9.502,2.142 L12.055,4.695 C11.619,4.928 11.218,5.225 10.86,5.584 Z M10.578,1.067 C9.154,-0.356 6.845,-0.356 5.4215,1.067 L0.849,5.64 L1.2828,5.64 C2.2242,5.64 3.11,6.006 3.776,6.672 L7.376,10.272 C7.636,10.533 8.061,10.532 8.321,10.272 L11.934,6.659 C12.6,5.993 13.486,5.626 14.427,5.626 L15.136,5.626 L10.578,1.067 L10.578,1.067 Z" id="Fill-4" fill="#009EE3" mask="url(#mask-6)" />
                </g>
                <g id="Group-9" transform="translate(0.000000, 6.000000)">
                  <mask id="mask-8" fill="white">
                    <use xlinkHref="#path-7" />
                  </mask>
                  <g id="Clip-8" />
                  <path d="M21.857,7.504 L19.566,9.795 L18.427,9.795 C18.178,9.795 17.934,9.6944 17.758,9.5177 L14.242,6 L17.758,2.482 C17.934,2.306 18.178,2.205 18.427,2.205 L19.566,2.205 L21.857,4.497 C22.258,4.898 22.479,5.432 22.479,6 C22.479,6.569 22.258,7.103 21.857,7.504 Z M5.951,9.504 C5.776,9.6808 5.532,9.7814 5.283,9.7814 L4.42,9.7814 L2.142,7.504 C1.314,6.675 1.313,5.326 2.142,4.497 L4.42,2.218 L5.283,2.218 C5.532,2.218 5.776,2.319 5.952,2.496 L9.456,6 L5.951,9.504 Z M22.931,3.422 L20.195,0.686 L18.427,0.686 C17.778,0.686 17.142,0.949 16.683,1.408 L13.07,5.022 C12.733,5.358 12.291,5.527 11.848,5.527 C11.406,5.527 10.963,5.358 10.627,5.021 L7.027,1.421 C6.568,0.962 5.932,0.698 5.283,0.698 L3.791,0.698 L1.068,3.422 C-0.356,4.846 -0.356,7.154 1.068,8.5782 L3.791,11.3019 L5.283,11.3019 C5.932,11.3019 6.568,11.0382 7.027,10.5792 L10.627,6.98 C11.279,6.326 12.418,6.327 13.071,6.979 L16.683,10.5919 C17.142,11.0509 17.778,11.3146 18.427,11.3146 L20.195,11.3146 L22.931,8.5782 C24.355,7.154 24.355,4.846 22.931,3.422 L22.931,3.422 Z" id="Fill-7" fill="#009EE3" mask="url(#mask-8)" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const PixSVG: FunctionComponent = () => (<PixMP />);

export default PixSVG;
